/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useCultivo } from "../../../hooks/useCultivo";
import { useVariedad } from "../../../hooks/useVariedad";

export const PedidoFilters = ({ values, setFieldValue, handleChange }) => {
  const { getVariedades } = useVariedad();
  const { getCultivo } = useCultivo();
  const [cultivoOptions, setCultivoOptions] = useState([]);
  const [variedadOptions, setVariedadOptions] = useState([]);

  useEffect(() => {
    const getCultivoList = async () => {
      const response = await getCultivo();
      setCultivoOptions(response);
      if (response && response.length === 1) {
        setFieldValue("id_cultivo", response[0].idcultivo);
      }
    };
    getCultivoList();
  }, []);

  useEffect(() => {
    const getVariedadList = async () => {
      const response = await getVariedades(values.id_cultivo);
      setVariedadOptions(response);
    };
    if (
      values.id_cultivo !== "" &&
      values.id_cultivo !== 0 &&
      values.id_cultivo !== "0"
    ) {
      getVariedadList();
    }
  }, [values.id_cultivo]);

  return (
    <div className="row">
      <div
        className="col-md-4 col-sm-12"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <label>Cultivo</label>
        <select
          className="form-control"
          value={values.id_cultivo}
          disabled={cultivoOptions.length === 1}
          onChange={handleChange}
          name="id_cultivo"
        >
          <option value="">Seleccionar...</option>
          {cultivoOptions.map((item) => (
            <option value={item.idcultivo} key={item.idcultivo}>
              {item.cultivo}
            </option>
          ))}
        </select>
      </div>
      <div
        className="col-md-4 col-sm-12"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <label>Fecha</label>
        <input
          type="date"
          className="form-control"
          value={values.fecha}
          onChange={handleChange}
          name="fecha"
        />
      </div>
      <div
        className="col-md-4 col-sm-12"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <label>Variedad</label>
        <select
          className="form-control"
          value={values.id_variedad}
          onChange={handleChange}
          name="id_variedad"
        >
          <option value="">Seleccionar...</option>
          {variedadOptions.map((item) => (
            <option value={item.idtipo} key={item.idtipo}>
              {item.tipo}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
